import { GAME_ID, REDUX_ACTIONS } from 'a/zoomBoom/data/constants';

const initialState = {
  displayBackground: false,
};

const instructionReducer = (state = initialState, { gameId, type }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.RESET_INSTRUCTION_BG:
      return initialState;

    case REDUX_ACTIONS.CHANGE_INSTRUCTION_BG:
      return {
        displayBackground: true,
      };

    default:
      return state;
  }
};

export default instructionReducer;
